import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const eventActionModalStyles = (theme: Theme) => ({
	root: {
		height: { xs: '100vh', sm: 'initial' },
		maxHeight: { xs: '100%', sm: 'initial' },
		minWidth: { xs: '80vw', lg: '70vw' },
		backgroundColor: Colors['FF6000'],
		py: { xs: '35px', md: '66px' },
		px: { xs: '10px', md: '48px' },
		borderRadius: '8px',
		display: 'flex',
		position: 'relative',
		gap: '20px',

		'@media screen and (max-width: 800px)': {
			flexDirection: 'column',
			alignItems: 'center',
		},
	},
	title: {
		mt: { xs: '60px', sm: '30px' },
		fontFamily: 'Integral CF',
		fontWeight: '700',
		fontSize: { xs: '24px' , sm: '26px', md: '30px', lg: '36px' },
		textAlign: { xs: 'center', sm: 'left' },
	},
	qrWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		px: '26px',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: '20px',

		'@media screen and (max-width: 800px)': {
			alignItems: 'center',
		},
	},
	phonesImageWrapper: {
		maxWidth: '600px',
		position: 'absolute',
		top: '-100px',
		right: '100px',

		'@media screen and (max-width: 1740px)': {
			position: 'static',
			mt: '-150px',
			mb: { xs: '-100px', sm: '-150px', md: '-200px' },
			width: '100%',
		},

		'@media screen and (max-width: 800px)': {
			mt: '0px',
		},
	},
	closeButton: {
		color: 'black',
		position: 'absolute',
		top: { xs: '35px', sm: '32px' },
		left: { xs: '25px', sm: '33px' },
	},
	storeButtons: {
		flexDirection: 'row',
	},
});
